import { memo } from "react";

const Close = ({ onClick, className, size = 28 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 28 28"
      onClick={onClick}
      style={{ cursor: "pointer" }}
      className={className}
    >
      <circle cx="14" cy="14" r="13" stroke="currentColor" strokeWidth="1" opacity="0.2" />
      <path
        d="M10 10l8 8M18 10l-8 8"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default memo(Close);
